import { useLayoutEffect, type RefObject } from 'react';

/** Toasts rise above whatever bar sits at the bottom of the board, whatever its height. */
export function usePublishBottomBar(ref: RefObject<HTMLElement | null>): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const measure = () => root.style.setProperty('--bottom-bar', `${el.offsetHeight}px`);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(el);
    return () => {
      observer?.disconnect();
      root.style.removeProperty('--bottom-bar');
    };
  }, [ref]);
}
